module.exports = __webpack_public_path__ + "img/20190929135412360截图20190929131652208.38668cb2.jpg";